module.exports = __webpack_public_path__ + "fonts/db56f17bd722d79fe3b3ab8f4b5d671f.svg";